import { render } from "./MatchingLocationsRadarChart.vue?vue&type=template&id=3a220652&ts=true"
import script from "./MatchingLocationsRadarChart.vue?vue&type=script&lang=ts"
export * from "./MatchingLocationsRadarChart.vue?vue&type=script&lang=ts"

import "./MatchingLocationsRadarChart.vue?vue&type=style&index=0&id=3a220652&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__